import { useState } from "react";
import { InputValidator } from "../types/Validate";

const useMultipleInputs = (numberOfInputs: number, validator: InputValidator) => {
  const [inputValues, setInputValues] = useState(Array(numberOfInputs).fill(""));
  const [errorMessage, setErrorMessage] = useState("");

  const onChange = (inputIndex: number) => (inputValue: string) => {
    const { hasError, message, isAllowInput } = validator?.(inputValue) ?? { hasError: false, message: "" };

    if (hasError) {
      setErrorMessage(message || "");

      if (isAllowInput) {
        setInputValues((prevInputs) => {
          const updatedInputs = [...prevInputs];
          updatedInputs[inputIndex] = inputValue;
          return updatedInputs;
        });
      }
      return;
    }

    setInputValues((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs[inputIndex] = inputValue;
      return updatedInputs;
    });
    setErrorMessage("");
  };

  return { inputValues, errorMessage, onChange };
};

export default useMultipleInputs;
